import { c as _c } from "react/compiler-runtime";
import { COMMUNITY_API } from 'modules/commutinies/api/community-api';
import { CommunityInterface } from 'modules/commutinies/types/community-interface';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from '@systemeio/util';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
export function useCommunities(t0) {
  const $ = _c(2);
  const shouldFetch = t0 === undefined ? true : t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [COMMUNITY_API, RequestModuleEnum.Community];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return useControlledSwr(t2, fetcher, undefined, shouldFetch && !!user);
}